import { render } from "./HelloWorld.vue?vue&type=template&id=2a1cd532&scoped=true"
import script from "./HelloWorld.vue?vue&type=script&lang=js"
export * from "./HelloWorld.vue?vue&type=script&lang=js"

import "./HelloWorld.vue?vue&type=style&index=0&id=2a1cd532&scoped=true&lang=stylus"

import exportComponent from "C:\\Users\\Administrator\\betaver_webpage\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a1cd532"]])

export default __exports__